import React from 'react'

import styles from './pricing-license-cards.module.scss'
import {combine} from '../styles/classname-utils'
import giftImage from '../../img/gift.svg'


const LicensePricingCards = () => (
  <div className={combine('mb-5', styles.container)}>
    <div className={styles.unlimitedCard}>
      <div className={styles.unlimitedBorder}>
        <div className={styles.unlimitedWrapper}>
          <img
            className={styles.unlimitedImage}
            src={giftImage}
            alt='A star shooting out of a gift box'
          />
          <div className={styles.unlimitedText}>
            <div className={combine('font8-bold', styles.unlimitedViews)}>
              Unlimited views
            </div>
            <div>
              <span className={styles.unlimitedPrice}>$3,000</span> / month
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className={combine('p-4', styles.otherCard)}>
      <div className={combine('text-center mb-4', styles.otherHeading)}>
        Pay every 3 or 6 months
      </div>
      <div className={styles.otherPrices}>
        <div className={combine('pr-3 pr-sm-4', styles.otherText)}>
          <div><span className='font8-semibold'>$2,700</span> / month</div>
          <div className={styles.billing}>
            billed every 3 months at <span className='font8-semibold'>$8,100</span>
          </div>
          <div className={styles.savings}>
            Save <span className='font8-semibold'>$900</span>
          </div>
        </div>
        <div className={combine('ml-3 ml-sm-4', styles.otherText)}>
          <div><span className='font8-semibold'>$2,250</span> / month</div>
          <div className={styles.billing}>
            billed every 6 months at <span className='font8-semibold'>$13,500</span>
          </div>
          <div className={styles.savings}>
            Save <span className='font8-semibold'>$4,500</span>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default LicensePricingCards
